<dx-popup
    class="popup"
    [width]="isPhoneOrTablet ? '90vw' : 900"
    [height]="'auto'"
    [showTitle]="true"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [showCloseButton]="false"
    [(visible)]="popupVisible"
    (onShown)="onShown()"
    [maxHeight]="'80vh'">
    <dxi-toolbar-item location="before">
        <h3 style="margin: 5px 0">Edit Insured</h3>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after">
        <dx-button text="Cancel" (click)="close()"></dx-button>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after">
        <dx-button text="Save" (click)="save()" style="margin-left: 8px;"></dx-button>
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view showScrollbar="onScroll">
            <div style="padding: 16px">
                <address>
                    <strong>Bill Type</strong>
                    {{ BillType }} <br/>
                    <strong>Payer</strong>
                    {{ Payer }}<br/>
                    <strong>Insurance Id</strong>
                    {{ InsuranceId }} <br/>
                </address>
                <div class="dx-field">
                    <div class="dx-field-value" style="width: auto!important; position: absolute;">
                        <dx-check-box
                            [(value)]="differentThanPatient"
                            (onValueChanged)="differentThanPatientValueChanged($event)"
                            text="Different than patient"
                        ></dx-check-box>
                    </div>
                </div>

                <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between">
                    <div fxLayout="column" fxFlex="30%" fxFlex.sm="50%" fxFlex.xs="100%" fxLayoutAlign="space-between"
                         style="padding-right: 8px" [ngStyle.xs]="{'padding-right': '0'}">
                        <div class="dx-field" style="width: 100% !important;">
                            <div class="dx-field-label">Last Name <i id='lastnameIcon' *ngIf="!patientBillingInformationTemp.lastName" class="dx-icon-warning"
                                                                     style="font-size: 16px; color: #ff9d09" title="Missing Information"></i></div>
                          <dx-tooltip target="#lastnameIcon" showEvent="dxhoverstart" hideEvent="dxhoverend">
                            <div *dxTemplate="let data of 'content'">
                              Missing information field.
                            </div>
                          </dx-tooltip>
                            <div class="dx-field-value" style="width: 100% !important;">
                                <dx-text-box class="uppercase" [width]="'100%'"
                                             [(value)]="patientBillingInformationTemp.lastName">
                                  <dx-validator validationGroup="billingInfo">
                                  </dx-validator>
                                </dx-text-box>
                            </div>
                        </div>
                        <div class="dx-field" style="width: 100% !important;">
                            <div class="dx-field-label">First Name <i id='fistnameIcon' *ngIf="!patientBillingInformationTemp.firstName" class="dx-icon-warning"
                                                                      style="font-size: 16px; color: #ff9d09" title="Missing Information"></i></div>
                          <dx-tooltip target="#fistnameIcon" showEvent="dxhoverstart" hideEvent="dxhoverend">
                            <div *dxTemplate="let data of 'content'">
                              Missing information field.
                            </div>
                          </dx-tooltip>
                            <div class="dx-field-value" style="width: 100% !important;">
                                <dx-text-box class="uppercase" [width]="'100%'"
                                             [(value)]="patientBillingInformationTemp.firstName">
                                  <dx-validator validationGroup="billingInfo">
                                  </dx-validator>
                                </dx-text-box>
                            </div>
                        </div>
                        <div class="dx-field" style="width: 100% !important;">
                            <div class="dx-field-label">Middle Name</div>
                            <div class="dx-field-value" style="width: 100% !important;">
                                <dx-text-box class="uppercase" [width]="'100%'"
                                             [(value)]="patientBillingInformationTemp.middleName">
                                  <dx-validator validationGroup="billingInfo">
                                  </dx-validator>
                                </dx-text-box>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between">
                            <div fxLayout="column" fxFlex="60%" fxLayoutAlign="space-between">
                                <div class="dx-field" style="width: 100% !important; padding-right: 2px!important;">
                                    <div class="dx-field-label" style="width: 100% !important;">Birth Date <i id='dohIcon' *ngIf="!patientBillingInformationTemp.birthDate" class="dx-icon-warning"
                                                                                                              style="font-size: 16px; color: #ff9d09" title="Missing Information"></i></div>
                                  <dx-tooltip target="#dohIcon" showEvent="dxhoverstart" hideEvent="dxhoverend">
                                    <div *dxTemplate="let data of 'content'">
                                      Missing information field.
                                    </div>
                                  </dx-tooltip>
                                    <div class="dx-field-value" style="width: 100% !important;">
                                        <dx-date-box type="date" height="26"
                                                     [(value)]="patientBillingInformationTemp.birthDate" [max]="today"
                                                     (onContentReady)="onContentReady($event)">
                                          <dx-validator validationGroup="billingInfo">
                                          </dx-validator>
                                        </dx-date-box>
                                    </div>
                                </div>
                                <div class="dx-field" style="width: 100% !important; padding-right: 2px!important;">
                                    <div class="dx-field-label" style="width: 100% !important;">Phone</div>
                                    <div class="dx-field-value" style="width: 100% !important;">
                                        <dx-text-box
                                            [(value)]="patientBillingInformationTemp.phone"
                                            mask="000-000-0000"
                                            [maskRules]="phoneMaskRule">
                                          <dx-validator validationGroup="billingInfo">
                                          </dx-validator>
                                        </dx-text-box>
                                    </div>
                                </div>
                            </div>
                            <div fxLayout="column" fxFlex="40%" fxLayoutAlign="space-between">
                                <div class="dx-field" style="width: 100% !important; padding-left: 2px!important;">
                                    <div class="dx-field-label" style="width: 100% !important;">Gender <i id='genderIcon' *ngIf="!patientBillingInformationTemp?.gender" class="dx-icon-warning"
                                                                                                          style="font-size: 16px; color: #ff9d09" title="Missing Information"></i></div>
                                  <dx-tooltip target="#genderIcon" showEvent="dxhoverstart" hideEvent="dxhoverend">
                                    <div *dxTemplate="let data of 'content'">
                                      Missing information field.
                                    </div>
                                  </dx-tooltip>
                                    <div class="dx-field-value" style="width: 100% !important;">
                                        <dx-select-box
                                            [dataSource]="gender"
                                            placeholder="Select patient gender..."
                                            [(value)]="patientBillingInformationTemp.gender">
                                          <dx-validator validationGroup="billingInfo">
                                          </dx-validator>
                                        </dx-select-box>
                                    </div>
                                </div>
                                <div class="dx-field" style="width: 100% !important; padding-left: 2px!important;">
                                    <div class="dx-field-label" style="width: 100% !important;">Relationship <i id='relationshipIcon' *ngIf="!patientBillingInformationTemp.relationship" class="dx-icon-warning"
                                                                                                                style="font-size: 16px; color: #ff9d09" title="Missing Information"></i></div>
                                  <dx-tooltip target="#relationshipIcon" showEvent="dxhoverstart" hideEvent="dxhoverend">
                                    <div *dxTemplate="let data of 'content'">
                                      Missing information field.
                                    </div>
                                  </dx-tooltip>
                                    <div class="dx-field-value" style="width: 100% !important;">
                                        <dx-select-box
                                            [dataSource]="relationshipWithInsured"
                                            [(value)]="patientBillingInformationTemp.relationship"
                                            [searchEnabled]="true">
                                          <dx-validator validationGroup="billingInfo">
                                          </dx-validator>
                                        </dx-select-box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div fxLayout="column" fxFlex="70%" fxFlex.sm="50%" fxFlex.xs="100%">
                        <app-address
                            style="width: 100%!important"
                            [addressControl]="addressControl"
                            [zipCodeControl]="zipCodeControl"
                            [zipCodeExtraControl]="zipCodeExtraControl"
                            [required]="false"
                            [warningIconForRequired]='true'
                            [loadInformation]="loadAddressInformation"
                            validationGroup="address"
                        ></app-address>
                    </div>
                </div>
            </div>
        </dx-scroll-view>
    </div>
</dx-popup>
<!--
</form>-->
